import React from "react";
import { Menu } from "antd";
import { Link } from 'react-router-dom'

const MainMenu = ({ menus, selectedKey, changeSelectedKey }) => {
  const styledMenu = [];
  menus.map((menu) => {
    if(menu.link){  
      styledMenu.push(
        <Menu.Item onClick={changeSelectedKey} key={menu.id}>
          <Link to={menu.link} >{menu.name}</Link>
        </Menu.Item>
      )
    }
    return '';
  })
  
  return (
    <Menu mode="inline" selectedKeys={[selectedKey]}>
      {styledMenu}
    </Menu>
  );
}
export default MainMenu